module.exports = axios;


//////////////////
// WEBPACK FOOTER
// external "axios"
// module id = 21
// module chunks = 0